/**
 * @generated SignedSource<<a6a8c71f5f1afa282471b7c614b7a657>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DateInlineEditCell_DateInlineEditCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "DateInlineEditCell_DateInlineEditCell";
};
export type DateInlineEditCell_DateInlineEditCell$key = {
  readonly " $data"?: DateInlineEditCell_DateInlineEditCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"DateInlineEditCell_DateInlineEditCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "DateInlineEditCell_DateInlineEditCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "1b7d630d3dcbf1130faba8a093d7e599";

export default node;
